import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom'
import { apiCall, removeParam } from '../../utils';


const ReportFilter = ({setFormData, hasDoctor = false, setAsOpen=false, strings = {
    START_DATE_STRING: 'Data Inicial',
    END_DATE_STRING: 'Data Final',
}}) => {
    return (
        <div className="col-12 p-2">
            <div className="d-flex justify-content-start mb-3">
                <button className="btn btn-secondary btn-lg js-admin-agenda-show-filters-button filter-show-button"><span className="pe-7s-filter"></span> {!setAsOpen ? 'Mostrar' : 'Esconder'} filtros</button>
            </div>
            <div className={`js-admin-agenda-filters filter-container ${!setAsOpen ? 'd-none' : ''}`}>
                <div className="form-group mb-3">
                    <label>Filial:</label>
                    <select className="form-control form-control js-business-branches-selector" onChange={(e) => {
                        var index = e.nativeEvent.target.selectedIndex;
                        var txt = e.nativeEvent.target[index].text
                        setFormData((prev) => {
                            return {
                                ...prev,
                                branch: e.target.value,
                                branchName: txt
                            }
                        });
                    }}>
                        <option selected default value="">-- Selecione --</option>
                    </select>
                </div>
                {hasDoctor && (
                    <div className="form-group mb-3">
                        <label>Doutor(a):</label>
                        <select className="form-control form-control js-business-doctors-selector" onChange={(e) => {
                            var index = e.nativeEvent.target.selectedIndex;
                            var txt = e.nativeEvent.target[index].text
                            setFormData((prev) => {
                                return {
                                    ...prev,
                                    doctor: e.target.value,
                                    doctorName: txt
                                }
                            });
                        }}>
                            <option selected default value="">-- Selecione --</option>
                        </select>
                    </div>
                )}
                <div className="form-group mb-3">
                    <label>{strings.START_DATE_STRING}:</label>
                    <input type="date" className="form-control" onChange={(e) => {
                        setFormData((prev) => {
                            return {
                                ...prev,
                                startDate: e.target.value
                            }
                        });
                    }} />
                </div>
                <div className="form-group mb-3">
                    <label>{strings.END_DATE_STRING}:</label>
                    <input type="date" className="form-control" onChange={(e) => {
                         setFormData((prev) => {
                            return {
                                ...prev,
                                endDate: e.target.value
                            }
                        });
                    }} />
                </div>
                <hr className="divider" />
            </div>
        </div>
    )
}
export default ReportFilter;